import AWS from 'aws-sdk'

class DeveloperPortalConfiguration {
    constructor() {
        this.apiId = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_API_ID');
        this.domainName = process.env['REACT_APP_SITE_DOMAIN'];
        this.awsRegion = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_REGION');
        this.cognitoRegion = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_REGION');
        this.cognitoUserPoolId = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_COGNITO_USER_POOL_ID');
        this.cognitoIdentityPoolId = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_COGNITO_IDENTITY_POOL_ID');
        this.cognitoClientId = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_COGNITO_USER_POOL_CLIENT_ID');
        this.siteS3Bucket = DeveloperPortalConfiguration.requiredEnvVariableValue('REACT_APP_SITE_S3_BUCKET');
        AWS.config.region = this.cognitoRegion;
    }

    static requiredEnvVariableValue(name) {
        const value = process.env[name];
        if(!value) {
            throw new Error(`environmental variable ${name} must be set before running / building`);
        }
        return value;
    }
}

export default new DeveloperPortalConfiguration();



/** WEBPACK FOOTER **
 ** ./src/services/DeveloperPortalConfiguration.js
 **/